import React, { useEffect, useState } from "react";
import http from "../http";
import CommentDetail from "../components/comment-detail-component";
import Spinner from "../components/UI/Spinner/Spinner.component";

const ViewComments = ({ match }) => {
  const [data, setData] = useState([]);
  const [commentsCount, setCommentsCount] = useState(null);
  const { articleID } = match.params;
  useEffect(() => {
    loadPageData(articleID);
  }, [articleID]);
  const loadPageData = async (articleID) => {
    try {
      const result = await http.get(`/comments/${articleID}`);
      setData(result.data.comments);
      setCommentsCount(result.data.totalCounts);
    } catch (err) {}
  };
  return (
    <div className="col-12 col-sm-12 col-md-8 col-lg-9">
      <div className="sectionTitle blueTitleBg clearfix d-flex">
        <h2 className="m-0 float-left mr-auto px-3">
          {!data.length ? "Loading..." : data[0]["GROUP_NAME"]}
        </h2>
      </div>
      <div className="commentsList">
        <h2 className="commentViewTitle pt-3">
          {" "}
          {!data.length ? null : data[0]["Article_Heading"]}
        </h2>
        {!data.length ? (
          <Spinner />
        ) : (
          <CommentDetail comments={data} CommentsCount={commentsCount} />
        )}
      </div>
    </div>
  );
};

export default ViewComments;
